import React from 'react';
import Box from 'relements/build/esm/ui/box';
import Toggle from 'relements/build/esm/input/toggle';
import Text from 'relements/build/esm/ui/text';
import {
  StyledSlider,
  StyledRangeWrap,
  StyledRangeValue,
} from '../taskBoxStyledComponents';

function ToggleDetailsContainer({
  handleToggle,
  toggleValue,
  SliderValue,
  sliderMinValue,
  sliderMaxValue,
  step,
  handleSlider,
  heading,
  subHeading,
}) {
  //  calculating the percentage we need to move the tooltip from left
  const newValue = Number(
    ((SliderValue - sliderMinValue) * 100) / (sliderMaxValue - sliderMinValue)
  );
  // to centralise the tooltip on the thumb.
  const newPosition = 10 - newValue * 0.2;
  // using this to calculate the position of tooltip on slider whenever slider moves
  const left = `calc(${newValue}% + (${newPosition}px))`;

  return (
    <Box
      flexDirection="column"
      padding="16px"
      borderStyle="solid"
      borderColor="grey.haptik"
      borderWidth="1px"
      width="326px"
      borderRadius="8px"
    >
      <Box padding="0" justifyContent="space-between" alignItems="center">
        <div>
          <Text variant="h4.semi-bold" color="black.haptik">
            {heading}
          </Text>
        </div>
        <div>
          {' '}
          <Toggle
            value={toggleValue}
            onChange={(value) => {
              handleToggle(value);
            }}
          />
        </div>
      </Box>
      <Box
        marginBottom={toggleValue ? '44px' : '0px'}
        marginTop="5px"
        padding="0"
      >
        <Text variant="body.md" color="grey.deep">
          {subHeading}
        </Text>
      </Box>
      {toggleValue && (
        <StyledRangeWrap>
          <StyledRangeValue left={left}>
            <span>{SliderValue}</span>
          </StyledRangeValue>
          <StyledSlider
            id="range"
            type="range"
            min={sliderMinValue}
            max={sliderMaxValue}
            value={SliderValue}
            step={step}
            onChange={(e) => {
              handleSlider(e);
            }}
          />
          <Box padding="0" justifyContent="space-between" marginTop="-7px">
            <Text variant="h5.semi-bold" color="black.haptik">
              {sliderMinValue}
            </Text>
            <Text variant="h5.semi-bold" color="black.haptik">
              {sliderMaxValue}
            </Text>
          </Box>
        </StyledRangeWrap>
      )}
    </Box>
  );
}
export default ToggleDetailsContainer;
